import React, { useState, useEffect } from "react";
import { useAuth } from "../../../Layouts/context/Authcontext";
import api from "../../../../api";
import { TailSpin } from 'react-loader-spinner';
import { getRoundRobinBaseUrl } from "../../../../loadBalancer";

const TopEfficiencyUsers = () => {
  const [topEffectivenessUsers, setTopEffectivenessUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const { accessToken } = useAuth();

  const colorClasses = [
    "bg-indigo-600",
    "bg-violet-500",
    "bg-pink-600",
    "bg-orange-500",
    "bg-emerald-500",
  ];

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      let baseUrls = getRoundRobinBaseUrl();
      const response = await api.get(
        `${baseUrls}/managerDashboard/getTop5`,
        {
          params: { month, year },
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      if (response.data.success) {
        setTopEffectivenessUsers(response.data.data.topEffectivenessUsers);
      } else {
        setError("Data fetch unsuccessful");
      }
    } catch (err) {
      setError("Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [accessToken, month, year]);

  const handleMonthChange = (e) => {
    setMonth(parseInt(e.target.value));
  };

  const handleYearChange = (e) => {
    setYear(parseInt(e.target.value));
  };

  const monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  const monthOptions = monthNames.map((name, index) => (
    <option key={index + 1} value={index + 1}>
      {name}
    </option>
  ));

  const currentYear = new Date().getFullYear();
  const yearOptions = [...Array(5).keys()].map(i => {
    const y = currentYear - i;
    return <option key={y} value={y}>{y}</option>;
  });

  return (
    <div className="bg-white shadow rounded-lg p-6 transition-transform hover:scale-[1.02] flex flex-col min-h-[460px]">
      {/* Header with filters */}
      <div className="flex justify-between items-center mb-4 bg-gray-100 rounded-md p-3">
        <h2 className="text-lg font-semibold text-gray-700">Top 5 Effectiveness Users</h2>
        <div className="flex gap-2">
          <select value={month} onChange={handleMonthChange} className="border rounded px-2 py-1 text-sm bg-white shadow-sm focus:outline-none">
            {monthOptions}
          </select>
          <select value={year} onChange={handleYearChange} className="border rounded px-2 py-1 text-sm bg-white shadow-sm focus:outline-none">
            {yearOptions}
          </select>
        </div>
      </div>

      {/* Content */}
      <div className="relative w-full flex-grow">
        {loading ? (
          <div className="absolute inset-0 flex flex-col justify-center items-center">
            <TailSpin height="50" width="50" color="#3b82f6" ariaLabel="loading" />
            <p className="text-gray-500 mt-2 text-sm">Loading data...</p>
          </div>
        ) : error ? (
          <div className="absolute inset-0 flex items-center justify-center text-red-500 text-sm">{error}</div>
        ) : topEffectivenessUsers.length === 0 ? (
          <div className="absolute inset-0 flex items-center justify-center text-gray-400 text-base">No data available for selected month</div>
        ) : (
          <div className="flex flex-col space-y-5">
            {topEffectivenessUsers.map((employee, index) => (
              <div
                key={employee.employeeId}
                className="flex items-center p-3 bg-gray-50 rounded-lg transition-transform hover:scale-105"
              >
                <div className="w-10 h-10">
                  <div
                    className={`${colorClasses[index % colorClasses.length]} rounded-full w-10 h-10 flex justify-center items-center text-white font-semibold shadow-md`}
                  >
                    {employee.employeeName.charAt(0) || "E"}
                  </div>
                </div>
                <div className="px-4 flex-1">
                  <div className="flex justify-between items-center mb-1">
                    <h6 className="font-semibold text-gray-700">
                      {employee.employeeName} - Emp ID {employee.employeeId}
                    </h6>
                    <p className="text-sm text-gray-600">
                      {employee.effectiveness.toFixed(2)}%
                    </p>
                  </div>
                  <div className="w-full rounded-full h-5 bg-gray-200 relative">
                    <div
                      className={`${colorClasses[index % colorClasses.length]} h-full rounded-full transition-all duration-500`}
                      style={{
                        width: `${Math.min(employee.effectiveness * 10, 100)}%`,
                      }}
                    >
                      <div className="absolute right-1 bg-white w-2 h-2 rounded-full" />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TopEfficiencyUsers;
